import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Page, PageContent, PageHeader } from '../components/common/index';
import { Spinner } from '../components/common';
import * as GoogleAnalytics from 'react-ga';

import quotingActions from '../quoting/quotingActions';
import userActions from '../user/userActions';
import policyActions from '../policy/policyActions';
import Utils from '../common/utils';

const qs = require('qs');

interface Props {
	user: UserDetails;
	customerDetails: CustomerDemographicDetails;
	customerPolicy: CustomerPolicy;

	actions: any;
	history: any;
	match: any;
	location: any;
}
interface State {
	workflow: React.StatelessComponent<any> | null;
}
class CampaignUnbouncePage extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
	}

	componentWillMount() {
		this.props.actions.resetUser();
		this.props.actions.resetCustomerDetails();
		this.props.actions.resetCustomerPolicy();
	}

	componentDidMount() {
		const queryString = this.props.location.search[0] === '?' 
		? this.props.location.search.slice(1) 
		: this.props.location.search;

		const parsed = qs.parse(queryString);
		const campaignCode: string = parsed.code;
		const birthdate: string = parsed.birthdate;
		const sex: string = (parsed.sex as string).toLowerCase();
		const isSmoker: boolean = parsed.smoker === '1';

		const user = {
			...this.props.user,
			birthdate: birthdate,
			gender: sex,
		};
		this.props.actions.saveUser(user)
		.then(() => {
			const age = Utils.getAgeRoundedFromBirthdate(birthdate);
			const customerDetails = {
				...this.props.customerDetails,
				age,
				isSmoker,
				customerId: this.props.user.id,
			};
			return this.props.actions.saveCustomerDetails(customerDetails);
		})
		.then(() => {
			const customerPolicy = {
				...this.props.customerPolicy,
				campaignCode,
				customerId: this.props.user.id,
			};
			return this.props.actions.setCustomerPolicy(customerPolicy);
		})
		.then(() => this.getQuote());
	}

	render() {
		return (
			<div className="navbar-account">
				<Page>
					<PageContent>
						<PageHeader isCentered={true} className="page-header-sm" title="Creating new application..." />
						<div className="mt-4 text-center">
							<Spinner />
							<p className="mt-3">One moment, please.</p>
						</div>
					</PageContent>
				</Page>		
			</div>);
	}

	getQuote = () => {
		const abTestIndex = Utils.getABTestOptimizeIndex();
		GoogleAnalytics.set({'exp': `Szj9gW87RKe5Yo5GErN82A.${abTestIndex}`});

		const url = Utils.getABTestWorkflowUrl(abTestIndex, this.props.customerDetails.age, this.props.user.gender);
		this.props.history.push(url);
	}
}

function mapStateToProps(state: any) {
	return {
		user: state.user.user,
		customerDetails: state.quoting.customerDetails,
		customerPolicy: state.policy.customerPolicy,
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...quotingActions, ...userActions, ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(CampaignUnbouncePage);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/CampaignUnbouncePage.tsx